// 这是将时间戳转换成天/小时/分/秒格式的组件
export function ts_time(d) {
    const i = parseInt(d)
    const day = parseInt(i/86400)
    const hour = parseInt(i/3600)%24
    const minute = parseInt((i%3600)/60)
    const second = parseInt(i%60)
    return day + "d " + hour + "h " + minute + "m " + second + "s"
}